import { groupPlanIdsByFolderKey } from "../groupPlanIdsByFolderKey";
import type { ImportFolder, ToImportFolders } from "./types";

export const toImportFolders: ToImportFolders = ({ drafts }) => {
  const planIdsByFolderKey = groupPlanIdsByFolderKey({ drafts });
  const importFolders: ImportFolder[] = [];
  for (const folder of drafts.folders) {
    const floorPlanIds = planIdsByFolderKey.get(folder.key);
    if (floorPlanIds !== undefined) {
      importFolders.push({ name: folder.name.trim(), floorPlanIds });
    }
  }
  return importFolders;
};
